import { fetchWithInterceptors } from 'utils/interceptors';

/**
 * Grabs partnerdata from url json location
 *
 * @param {object} parameters
 *
 * @returns {Promise}
 */
export async function getPartnerData({ isPreview, url }: { isPreview: boolean; url: string }) {
  const fetchOptions: RequestInit = {
    method: 'GET',
    credentials: isPreview ? 'include' : 'same-origin',
  };
  const res = await fetchWithInterceptors(url, fetchOptions);
  return res.json();
}
